export default "dist/images/components-columns-width-control-3-1.b0d994b.png";